import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { PQR_TIMES, PQR_TIMES_DETAIL } from '../../../../../routes/paths';
import {
    PqrTimeFull,
    PqrTimeDate,
    PqrTime,
} from '../../../../../shared/types/paramPqrTimes';
import { Historical } from '../../../../../shared/types/shared';
import {
    asyncCreatePqrTime,
    asyncUpdatePqrTime,
    asyncGetPqrTime,
    asyncGetPqrTimeHistorical,
} from '../../../../../services/pqr-times.service';

export const usePqrTimesForm = () => {
    const navigate = useNavigate();
    const { idPqrTimes } = useParams();
    const [pqrTimes, setPqrTimes] = useState<PqrTimeFull>();
    const [loading, setLoading] = useState(false);
    const [formikPqrTimesData, setFormikPqrTimesData] =
        useState<FormikProps<PqrTime>>();
    const [formikPqrTimesDates, setFormikPqrTimesDates] =
        useState<FormikProps<PqrTimeDate>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [pqrTimesHistorical, setPqrTimesHistorical] =
        useState<Historical[]>();

    const isValidForm = formikPqrTimesData?.isValid;
    const isValidFormDates = formikPqrTimesDates?.isValid;

    const handleCleanAndBack = () => {
        formikPqrTimesData?.resetForm();
        navigate(PQR_TIMES);
    };

    const handleSubmit = async () => {
        await formikPqrTimesDates?.submitForm();
        await formikPqrTimesData?.submitForm();

        if (!isValidForm) return;
        if (!isValidFormDates) return;

        setLoading(true);

        const data: PqrTimeFull = {
            ...formikPqrTimesData?.values,
            ...formikPqrTimesDates?.values,
        };
        let res: any | undefined = undefined;
        delete data.rule;

        try {
            if (pqrTimes && pqrTimes.id)
                res = await asyncUpdatePqrTime(pqrTimes.id, data);
            else res = await asyncCreatePqrTime(data);
        } catch (error) {}
        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! la regla de estado de PQR se ${
                    pqrTimes && pqrTimes.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PQR_TIMES_DETAIL}/${res.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    pqrTimes && pqrTimes.id ? 'actualizar' : 'crear'
                } el estado de PQR. Por favor, asegúrate de ${
                    pqrTimes && pqrTimes.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idPqrTimes)) {
            setLoading(true);
            asyncGetPqrTime(idPqrTimes)
                .then((pqrTimes: any) => {
                    if (!pqrTimes) navigate(PQR_TIMES);
                    setPqrTimes(pqrTimes);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqrTimes]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrTimeHistorical(idPqrTimes)
                .then((resp) => {
                    if (resp) setPqrTimesHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        pqrTimes,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrTimesData,
        setFormikPqrTimesDates,
        pqrTimesHistorical,
        showHistorical,
        setShowHistorical,
    };
};
